module.exports = __webpack_public_path__ + "static/media/earn_money.782fa888.png";